import { X } from "lucide-react";
import { Policy } from ".";

function PolicySelectionModal({
  availablePolicies,
  onSelectPolicy,
  onClose,
  stepNumber,
  renderIconByName,
}: {
  availablePolicies: Policy[];
  onSelectPolicy: (policy: Policy) => void;
  onClose: () => void;
  stepNumber: number;
  renderIconByName: (iconName: string) => React.ReactNode;
}) 
{
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handlePolicyClick = (policy: Policy) => {
    onSelectPolicy(policy);
    onClose();
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content-sequence">
        <div className="modal-header">
          <h3 className="modal-title">Select Policy for Step {stepNumber}</h3>
          <button
            className="modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            <X />
          </button>
        </div>
        <div className="modal-body">
          <p className="modal-description">
            Choose a policy to add as Step {stepNumber}
          </p>
          <div className="modal-policies-grid">
            {availablePolicies.map((policy) => (
              <div
                key={policy.id}
                className="modal-policy-card"
                onClick={() => handlePolicyClick(policy)}
              >
                <div className={`modal-policy-icon ${policy.iconColor}`}>
                  {renderIconByName(policy.icon)}
                </div>
                <div className="modal-policy-info">
                  <h4 className="modal-policy-name">{policy.name}</h4>
                  <p className="modal-policy-desc">{policy.description}</p>
                </div>
              </div>
            ))}
          </div>
          {availablePolicies.length === 0 && (
            <div className="modal-empty">
              <p>All policies have been used</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default PolicySelectionModal;
